import React from "react";

// Official MediGenie mascot images.
// `variant` picks which illustration to use.
// "main"    = standing full-body MediGenie (default)
// "avatar"  = close-up headshot (chat avatar / compact placements)
// "empty"   = crossed-arms genie (empty and secondary states)
const SOURCES = {
  // Versioned URLs prevent browsers/CDNs from retaining the previous artwork.
  main: "/mascot/main.png?v=20260815-2",
  avatar: "/mascot/avatar.png?v=20260815-2",
  empty: "/mascot/empty.png?v=20260815-2",
};

export function Mascot({ size = 64, variant = "main", className = "", round = false }) {
  const src = SOURCES[variant] || SOURCES.main;
  const isHead = variant === "avatar";
  // Keep aspect ratio for the full-body illustrations; avatar is square.
  const style = isHead
    ? { width: size, height: size, objectFit: "cover" }
    : { height: size, width: "auto", objectFit: "contain" };
  return (
    <img
      src={src}
      alt="MediGenie mascot"
      className={`select-none pointer-events-none ${round ? "rounded-full" : ""} ${className}`}
      style={style}
      draggable={false}
    />
  );
}

// Magical golden lamp — kept as SVG for crisp use in small UI accents.
export function Lamp({ size = 48, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={`lamp-grad-${size}`} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F4B000" />
          <stop offset="1" stopColor="#FFE08A" />
        </linearGradient>
      </defs>
      <ellipse cx="32" cy="46" rx="22" ry="10" fill={`url(#lamp-grad-${size})`} />
      <path d="M50 44 Q58 44 56 38 Q58 36 52 36" stroke="#F4B000" strokeWidth="3" fill="none" strokeLinecap="round" />
      <ellipse cx="32" cy="38" rx="14" ry="3" fill="#F4B000" />
      <circle cx="20" cy="36" r="2" fill="#FFE08A" />
    </svg>
  );
}
